/**
 * Determines if an employee is from India based on country name
 * @param country The country name or code
 * @returns true if the country is India
 */
export const isIndianEmployee = (country?: string): boolean => {
  return country === 'India';
};
